import useTranslator from "../../hooks/useTranslator";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import AuthContext from "../../context/auth/AuthContext";
import TenantContext from "../../context/tenant/TenantContext";
import DeleteConfiration from "./DeleteConfiration";
import { getGuarantorStatus, toast } from "../../helper/common";
import { Icon } from "../design";
import {
  GuarantorCard,
  GuarantorMenu,
  GuarantorStatusBadge,
} from "./GuarantorCardParts";

const PendingFlaggedGuarantors = ({
  allUsers,
  userData,
  llShowOnly,
  isDropdown,
  setIsDropdown,
  readOnly = false,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();

  const { loadUser } = useContext(AuthContext);
  const { upsertSelectedOnboardingUsers } = useContext(TenantContext);
  const [showDeleteConfirmationPrompt, setShowDeleteConfirmationPrompt] =
    useState(false);
  const [deleteGuarantorLoading, setDeleteGuarantorLoading] = useState(false);

  const handleCompleteOnboarding = () => {
    const params = new URLSearchParams({
      guarantorName: userData?.name || "",
    });
    const [firstName = "", ...lastNameParts] = (userData?.name || "")
      .trim()
      .split(/\s+/);
    params.set("firstName", firstName);
    if (lastNameParts.length) params.set("lastName", lastNameParts.join(" "));
    if (userData?.email) {
      params.set("email", userData.email);
    }
    const relation = userData?.gurantor_relation || userData?.relation;
    if (relation) params.set("gurantor_relation", relation);
    navigate(`/guarantor/onboarding?${params.toString()}`);
  };

  const deleteGuarantor = async () => {
    try {
      setDeleteGuarantorLoading(true);
      const updatedUsers = Array.isArray(allUsers)
        ? allUsers.filter(
            (user) => user.type === "guarantor" && user?.name !== userData?.name
          )
        : [];
      const userid = localStorage.getItem("saveduserid");
      const payload = {
        tenant_id: userid,
        users: updatedUsers,
      };
      await upsertSelectedOnboardingUsers(payload);
      loadUser("tenant");
      setShowDeleteConfirmationPrompt(false);
    } catch (err) {
      toast.error(_t("failedToDeleteGuarantor"));
    } finally {
      setDeleteGuarantorLoading(false);
    }
  };

  const menuItems = [
    {
      key: "complete",
      label: _t("completeAdding"),
      icon: <Icon name="plus" />,
      onClick: handleCompleteOnboarding,
    },
    {
      key: "delete",
      label: _t("delete"),
      icon: <Icon name="trash" />,
      danger: true,
      onClick: () => {
        setIsDropdown(false);
        setShowDeleteConfirmationPrompt(true);
      },
    },
  ];

  return (
    <>
      <GuarantorCard
        name={userData?.name ?? ""}
        onClick={() => isDropdown && setIsDropdown(false)}
        status={
          <GuarantorStatusBadge
            statusData={getGuarantorStatus(
              "pendingDetails",
              userData?.guarantor_id
            )}
          />
        }
        menu={
          !llShowOnly && !readOnly ? (
            <GuarantorMenu
              label={_t("more", "More")}
              items={menuItems}
              open={isDropdown}
              onToggle={() => setIsDropdown(!isDropdown)}
            />
          ) : null
        }
      />
      <DeleteConfiration
        isOpen={showDeleteConfirmationPrompt}
        onClose={() => setShowDeleteConfirmationPrompt(false)}
        name={`${userData?.name ?? ""}` ?? ""}
        relation={userData?.gurantor_relation ?? ""}
        heading={_t("deleteGuarantor")}
        description={_t("areYouSureDoYouWantToDeleteThisGuarantor")}
        btn1Text={_t("noGoBack")}
        btn2Text={_t("yesDelete")}
        btn1Functionality={() => setShowDeleteConfirmationPrompt(false)}
        btn2Functionality={() => deleteGuarantor()}
        submitLoading={deleteGuarantorLoading}
      />
    </>
  );
};

export default PendingFlaggedGuarantors;
